
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/doubletick",
      function () {
        return require("private-next-pages/compare/doubletick.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/doubletick"])
      });
    }
  